import { render, staticRenderFns } from "./customizationEvents.vue?vue&type=template&id=6c0c8f2c&scoped=true&"
import script from "./customizationEvents.vue?vue&type=script&lang=js&"
export * from "./customizationEvents.vue?vue&type=script&lang=js&"
import style0 from "./customizationEvents.vue?vue&type=style&index=0&id=6c0c8f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c8f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0c8f2c')) {
      api.createRecord('6c0c8f2c', component.options)
    } else {
      api.reload('6c0c8f2c', component.options)
    }
    module.hot.accept("./customizationEvents.vue?vue&type=template&id=6c0c8f2c&scoped=true&", function () {
      api.rerender('6c0c8f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/retentionAnalysis/customizationEvents.vue"
export default component.exports